import { StyleProps, Text, useToast } from "@chakra-ui/react";
import { useMemo } from "react";

import { ColumnTitle } from "@components/ColumnTitle/ColumnTitle";
import { ConsumptionsBox } from "@components/ConsumptionsBox/ConsumptionsBox";
import { PageShellWithThreeColumns } from "@components/PageShellWithThreeColumns/PageShellWithThreeColumns";
import { useAuthContext } from "@hooks/useAuthContext";
import { ConsumptionScope, useConsumptions } from "@hooks/useConsumptions";
import { $g1Color } from "@/theme/G1Style";
import { defaultErrorToast } from "@utils/toast";

export const ConsumptionsView = ({ maxWidth }: StyleProps) => {
    const { connectedUser } = useAuthContext();
    const scope = useMemo<ConsumptionScope>(
       () => ({ type: "all" }),
        [connectedUser]
    );
    const { nbFrees, nbPaid, nbRefused, inProgress, lastyearConsumptions, exportFileConsumptions } = useConsumptions(connectedUser, scope);
    const toast = useToast();

    const onExportConsumptions = async () => {
        try {
            await exportFileConsumptions();
        } catch (e) {
            toast(defaultErrorToast("Problème rencontré lors de l'export des données")) ;
        }
    }

    return (
        <PageShellWithThreeColumns
          centralContent={
              <>
              <ColumnTitle color={$g1Color('global.write')}>
                  <Text>Consommations</Text>
              </ColumnTitle>
              <ConsumptionsBox maxWidth={maxWidth} currentMonth={{ nbPaid, nbFrees, nbRefused, inProgress }} allConsumptions={lastyearConsumptions} onExport={onExportConsumptions} />
              </>
          }
        />
    );
} ;